import { auth } from "../components/firestore_user";

/**
 * fetch() with Firebase ID token when a user is signed in (required by distribution API in production).
 * Uses the same Firebase app as login ("secondary" in firestore_user) — not firebase.auth() default app.
 * When AUTH_DISABLED=true on the server, requests may rely on user_id query params without a token.
 */
export async function authFetch(url, options = {}) {
  const headers = {
    Accept: "application/json",
    ...(options.headers || {}),
  };
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      headers.Authorization = `Bearer ${token}`;
    } catch (e) {
      console.warn("getIdToken failed", e);
    }
  }
  return fetch(url, { ...options, headers });
}
